import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-info-variety',
  templateUrl: './info-variety.component.html',
  styleUrls: ['./info-variety.component.css']
})
export class InfoVarietyComponent implements OnInit {
  leftMenu1 = true;
  leftMenu2 = false;
  leftMenu3 = false;

  constructor(private service: LoginService, private router: Router) { }

  ngOnInit() {

  }

  info(num: number) {
    switch (num) {
      case 1:
        localStorage.setItem('type', "中心动态")
        this.router.navigate(["/infoVariety/centerNews"])
        this.leftMenu1 = true
        this.leftMenu2 = false
        this.leftMenu3 = false
        break
      case 2:
        localStorage.setItem('type', "行业动态")
        this.router.navigate(["/infoVariety/industryNews"])
        this.leftMenu1 = false
        this.leftMenu2 = true
        this.leftMenu3 = false
        break
      case 3:
        localStorage.setItem('type', "政策法规")
        this.router.navigate(["/infoVariety/noticeAnnouncement"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = true
        break
    }

  }
}
